module.exports = __webpack_public_path__ + "img/744.36898f1d.jpg";